var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/loyalty-subscribed.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<ul>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "Profile") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"subscriptions")),"loyalty")),"loyaltyDate")) {
output += "\n\n        ";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"subscriptions")),"loyalty")),"loyaltyDate");
frame.set("loyaltyDate", t_1, true);
if(frame.topLevel) {
context.setVariable("loyaltyDate", t_1);
}
if(frame.topLevel) {
context.addExport("loyaltyDate", t_1);
}
output += "\n\n    ";
;
}
else {
output += "\n\n        ";
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup(((lineno = 8, colno = 48, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"subscriptions"), "helpers[\"subscriptions\"]", context, []))),"loyalty")),"loyaltyDate");
frame.set("loyaltyDate", t_2, true);
if(frame.topLevel) {
context.setVariable("loyaltyDate", t_2);
}
if(frame.topLevel) {
context.addExport("loyaltyDate", t_2);
}
output += "\n\n    ";
;
}
output += "\n\n    <li>\n\n        <span class=\"u-global-h5\">";
output += runtime.suppressValue((lineno = 14, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-loyalty-member-date",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += ":</span>\n        <span class=\"u-global-p\"> ";
output += runtime.suppressValue((lineno = 15, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-loyalty-since",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(env.getFilter("format_unix_timestamp").call(context, runtime.contextOrFrameLookup(context, frame, "loyaltyDate"),"YYYY"), env.opts.autoescape);
output += "</span>\n\n    </li>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "Profile") && runtime.memberLookup((runtime.memberLookup(((lineno = 19, colno = 31, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"dateOfBirth")),"year") && runtime.memberLookup((runtime.memberLookup(((lineno = 19, colno = 75, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"dateOfBirth")),"month") && runtime.memberLookup((runtime.memberLookup(((lineno = 19, colno = 120, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"dateOfBirth")),"day")) {
output += "\n\n        ";
var t_3;
t_3 = runtime.memberLookup((runtime.memberLookup(((lineno = 21, colno = 35, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"dateOfBirth")),"year") + "" + "-" + "" + runtime.memberLookup((runtime.memberLookup(((lineno = 21, colno = 83, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"dateOfBirth")),"month") + "" + "-" + "" + runtime.memberLookup((runtime.memberLookup(((lineno = 21, colno = 132, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"dateOfBirth")),"day");
frame.set("birthday", t_3, true);
if(frame.topLevel) {
context.setVariable("birthday", t_3);
}
if(frame.topLevel) {
context.addExport("birthday", t_3);
}
output += "\n\n    ";
;
}
else {
output += "\n\n        ";
var t_4;
t_4 = runtime.memberLookup((runtime.memberLookup(((lineno = 25, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"profile"), "helpers[\"profile\"]", context, []))),"dateOfBirth")),"year") + "" + "-" + "" + runtime.memberLookup((runtime.memberLookup(((lineno = 25, colno = 82, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"profile"), "helpers[\"profile\"]", context, []))),"dateOfBirth")),"month") + "" + "-" + "" + runtime.memberLookup((runtime.memberLookup(((lineno = 25, colno = 126, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"profile"), "helpers[\"profile\"]", context, []))),"dateOfBirth")),"day");
frame.set("birthday", t_4, true);
if(frame.topLevel) {
context.setVariable("birthday", t_4);
}
if(frame.topLevel) {
context.addExport("birthday", t_4);
}
output += "\n\n    ";
;
}
output += "\n\n    <li>\n\n        <span class=\"u-global-h5\">";
output += runtime.suppressValue((lineno = 31, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-loyalty-birthday",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += ":</span>\n        <span class=\"u-global-p\">";
output += runtime.suppressValue(env.getFilter("format_iso_datetime").call(context, runtime.contextOrFrameLookup(context, frame, "birthday"),"MMMM D"), env.opts.autoescape);
output += "</span>\n\n    </li>\n\n</ul>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/loyalty-subscribed.j2"] , dependencies)